import { forwardRef } from "react";

interface PurchaseBarContainerProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const PurchaseBarContainer = forwardRef(
  ({ children, className = "", style }: PurchaseBarContainerProps, ref: React.Ref<HTMLDivElement>) => (
    <div ref={ref} className="tw-sticky tw-bottom-[24px] tw-w-full tw-mx-auto" style={style}>
      <div
        className={`${className} tw-mx-[16px] tw-flex tw-justify-between tw-items-center tw-gap-[16px] tw-flex-wrap tw-bg-white tw-rounded-[8px] tw-p-[24px] tw-shadow-dropdown tw-group hover:tw-shadow-[0px_0px_32px_2px_rgba(89,196,196,0.20)] tw-transition-all tw-border-solid tw-border-[1px] tw-border-gray-5 hover:tw-border-[2px] hover:tw-border-theme-primary ${open ? "tw-border-[2px] tw-border-theme-primary" : ""}`}
      >
        {children}
      </div>
    </div>
  ),
);

export default PurchaseBarContainer;
